import React from 'react'
import classnames from 'classnames'
import { Button } from '@deal/components'
import styles from './styles.css'

interface Question {
  title: string
  subtext: string
}

interface Props {
  fullPageTakeoverImage?: string | null
  header: string
  onSubmitModal: (categorySlug: string | null) => void
  categorySlug: string
  buttonText?: string
  questionsTitle?: string
  questions: Question[]
  onDismissModal: () => void
  dismissButtonText?: string
  dissmissButtonPlacement?: 'top' | 'bottom'
  small?: boolean
  className?: string
}

const GradientTakeover: React.SFC<Props> = ({
  fullPageTakeoverImage,
  header,
  onSubmitModal,
  categorySlug,
  buttonText,
  questionsTitle,
  questions,
  onDismissModal,
  dismissButtonText,
  dissmissButtonPlacement = 'bottom',
  small,
  className
}) => (
  <>
    <div className={styles.gradientMask} />
    <div
      className={styles.background}
      style={{
        backgroundImage: fullPageTakeoverImage
          ? `url(${fullPageTakeoverImage}?auto=compress%2Cformat)`
          : ''
      }}
    />
    <div className={classnames(styles.content, className)}>
      <div className={small ? styles.headerSmall : styles.header}>{header}</div>
      <div className={small ? styles.actionSmall : styles.action}>
        <Button size={small ? 'medium' : 'large'} onClick={() => onSubmitModal(categorySlug)}>
          {buttonText ? buttonText : 'Get started'}
        </Button>
        {dissmissButtonPlacement === 'top' && (
          <Button
            variant="clear-black"
            size={small ? 'medium' : 'large'}
            onClick={onDismissModal}
            className={styles.actionDismiss}
          >
            {dismissButtonText ? dismissButtonText : 'Maybe later'}
          </Button>
        )}
      </div>
      <div className={small ? styles.stepsSmall : styles.steps}>
        {questionsTitle && <div className={styles.stepsTitle}>{questionsTitle}</div>}
        {questions.map((question, idx) => (
          <div className={styles.step} key={idx}>
            <div className={small ? styles.stepHeaderSmall : styles.stepHeader}>
              {question.title}
            </div>
            <div className={small ? styles.stepBodySmall : styles.stepBody}>{question.subtext}</div>
          </div>
        ))}
      </div>
      {dissmissButtonPlacement === 'bottom' && (
        <div className={styles.dismiss}>
          <Button variant="link" onClick={onDismissModal}>
            {dismissButtonText ? dismissButtonText : 'Maybe later'}
          </Button>
        </div>
      )}
    </div>
  </>
)

export default GradientTakeover
